export const PAYMENT = 1;
export const RECEIVE = 2;
export const ACTIVITY = 3;
export const TRANSFER = 4;

export const Names = {
  [PAYMENT]: "پرداخت",
  [RECEIVE]: "دریافت",
  [ACTIVITY]: "کارکرد",
  [TRANSFER]: "انتقالی"
};
